import './styles.css';

export default function BalanceSheetRow({
  name,
  value,
  isNegative,
  hasChildren,
  isChild
}) {

  return (
    <div className={`income-statement-row ${hasChildren ? 'has-children' : 0} ${isChild ? 'child' : ''}`}>
      <span>{name}</span>
      <span className={isNegative ? 'negative' : ''}>{value}</span>
    </div>
  );
}
